var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"footer__container container"},[_c('span',{staticClass:"footer__copy"},[_vm._v("© TeRoom "+_vm._s((new Date).getFullYear()))]),_c('FooterSupport',{staticClass:"footer__support"})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }